"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _CssBaseline = _interopRequireDefault(require("@material-ui/core/CssBaseline"));

var _Header = _interopRequireDefault(require("../components/Header"));

var _Footer = _interopRequireDefault(require("../components/Footer"));

var _ErrorBoundary = _interopRequireDefault(require("../components/ErrorBoundary"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var App = function App(_ref) {
  var routes = _ref.routes,
      version = _ref.version,
      authProps = _objectWithoutProperties(_ref, ["routes", "version"]);

  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "rootComponent"
  }, /*#__PURE__*/_react["default"].createElement(_CssBaseline["default"], null), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Header["default"], _extends({
    links: routes.map(function (_ref2) {
      var name = _ref2.name,
          path = _ref2.path,
          exact = _ref2.exact,
          badgeContent = _ref2.badgeContent;
      return {
        name: name,
        to: path,
        exact: exact,
        badgeContent: badgeContent
      };
    })
  }, authProps))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_ErrorBoundary["default"], null, /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Switch, null, routes.map(function (_ref3) {
    var component = _ref3.component,
        exact = _ref3.exact,
        path = _ref3.path;
    return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
      path: path,
      component: component,
      exact: exact,
      key: path
    });
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Redirect, {
    from: "/staff",
    to: "/"
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Route, {
    component: routes.length > 0 ? routes[0].component : ""
  })))), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_Footer["default"], {
    version: version
  }))));
};

App.propTypes = {
  routes: _propTypes["default"].array
};
App.defaultProps = {
  routes: []
};
var _default = App;
exports["default"] = _default;